import { useEffect, useRef, useState } from 'react'

import logo from '../../resources/images/logo-white-text.png';
import '../../stylesheets/home.css'

import { Link } from 'react-router-dom';

import eventsDetails from '../../utility/event-details';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import useWindowDimensions from '../../utility/getWindowDimensions'

const Home = (props) => {
	useEffect(() => {
		props.setOnPage(1)
	}, [props])

	const { width } = useWindowDimensions();

	const[hideEventsBtn, setHideEventsBtn] = useState(width < 600);

	const aboutUsref = useRef(null);
	const scrollToAboutUs = () => {
		aboutUsref.current?.scrollIntoView({ behavior: 'smooth' });
	};

	function eventsToShow(evt) {
		const today = new Date();

		return (evt.endDate > today);
	}

	const filteredEvents = eventsDetails.filter(eventsToShow);

	return (
		<>
			{
				filteredEvents?.length ?
				<div id="eventsToShow" className={`${hideEventsBtn ? 'hideEvts' : ''}`}>
					<div className="hideEventsButton" onClick={()=> setHideEventsBtn(prev => !prev)}>
						<div className={`hideBtn${hideEventsBtn ? ' rotate-90' : ''}`}></div>
					</div>
					<div className="eventsTagDetails">
						<h2>Upcoming Events</h2>
						<div className='eventsTagName'>
							<ul>
								{
									filteredEvents.map((evt, key)=>{
										return (
											<li title={evt.name} className='underline' key={key}>
												<Link to={evt.url}>
													{evt.name} &gt;
												</Link>
											</li>
										)
									})
								}
							</ul>
						</div>
					</div>
				</div>
				:<></>
			}

			<div className="circle" id="circle1"></div>
			<div className="circle" id="circle2"></div>
			<div className="circle" id="circle3"></div>

			<div id="home">
				<div className="hero-section">
					<div className="hero-img-wrapper">
						<img src={logo} alt="" />
					</div>
					<div className="home-title-text">
						DJ Sanghvi's
						<br />
						National Student Data Corps
					</div>
					<div className="home-title-subtext">
						DJ Sanghvi's first Student Chapter for Data Visualization and Machine Learning <br />from the brand new branch of AI & Data Science
					</div>
					<div className="home-driver-text">
						Let the Dataset change your Mindset.
					</div>
					<div className="home-button">
						<button onClick={scrollToAboutUs}>
							About Us
							<div className="next-arrow">
								<FontAwesomeIcon icon={faArrowRight} />
							</div>
						</button>
					</div>
				</div>

				<div ref={aboutUsref} className="curve-design">
					<div className="curve-design-lower"></div>
					<p>About Us</p>
				</div>

				<div id="about-us-section">
					<p>
						DJ Sanghvi's National Student Data Corps comes under the Artificial Intelligence and Data Science Department and was founded in January 2023. An initiative by the Northeast Big Data Hub, it helps you evolve with this ever changing field and promotes interaction and brainstorming with fellow enthusiasts
					</p>
				</div>
			</div>
		</>
	)
}

export default Home